import useSignupData from '@assetron/common/hooks/useSignupData';
import HeaderFooterLayout from '@assetron/web-common/layout/HeaderFooterLayout';
import { useNavigation } from '../../navigation/useNavigation';
import AssetronOverlayDialog from '@assetron/web-common/components/common/AssetronOverlayDialog';
import EnterEmailContent from './EnterEmailContent';

function EnterEmail() {
  const { clearInfo } = useSignupData();
  const { navigateToSignInLanding } = useNavigation();

  function handleClose() {
    clearInfo();
    navigateToSignInLanding();
  }
  return (
    <HeaderFooterLayout>
      <AssetronOverlayDialog
        open
        content={<EnterEmailContent />}
        onClose={handleClose}
        isLogoVisible
      />
    </HeaderFooterLayout>
  );
}

export default EnterEmail;
